const limitSeriesDataToTenYears = (series: any, performaceResetDate: any) => {
    const data = [];
    let _seriesData = series;

    if (performaceResetDate) {
        _seriesData = series?.filter((v: any) => new Date(v.date) >= new Date(performaceResetDate));
    }

    const seriesData = _seriesData.reduce((acc: any, d: any) => {
        acc[d.date] = d.value;
        return acc;
    }, {});

    const dates = Object.keys(seriesData).sort();

    const nDates = dates.length;

    if (nDates) {
        // We can show a max of 120 datapoints (= 10 years).
        const maxLength = Math.min(nDates, 120);
        const firstDateIndex = nDates - maxLength;

        for (let i = firstDateIndex; i < nDates; i++) {
            const d = dates[i];
            data.push({ date: d, value: seriesData[d] });
        }
    }

    return data;
};

export function prepareData(
    rawData: any,
    isLimitToTenYears: boolean,
    performaceResetDate: any,
    investmentAmount: number,
    useSimpleDataset?: boolean,
    yAxisValueOverride?: boolean
) {
    return Array.isArray(rawData)
        ? rawData.map((r: any, i: number) => {
              const _values = isLimitToTenYears
                  ? limitSeriesDataToTenYears(r?.values, performaceResetDate)
                  : r?.values;
              const preparedData = _values.map((o: any) => {
                  const d = o.date;
                  const splitDate = d.split('-');
                  const year = splitDate[0];
                  const month = splitDate[1] - 1;
                  const day = splitDate[2];
                  const date = Date.UTC(year, month, day);
                  const amount = investmentAmount / _values?.[0]?.value;

                  if (useSimpleDataset) {
                      return [date, o.value * amount];
                  }

                  return {
                      x: date,
                      // rebase data as per investment value
                      y: yAxisValueOverride ? o.value : o.value * amount,
                      ...o, // map other raw data normally
                  };
              });
              return { name: r.name, isCurrent: r.isCurrent, data: preparedData, visible: i < 2 };
          })
        : [];
}
